import React from 'react';
import { Component } from '@poa/core';
import { observable } from '@poa/state';


class GeneralAiReport extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa
    env; // injected by Poa

    pollingTimeoutId = null;
    isPollingActive = false;

    localState = observable({
        showAddReportTooltip: false,
        newReportName: '',
        newReportText: '',
        reports: this.store.generalProfile.reports || [],
        templates: [],
        editReportId: null,
        save_template: false
    });

    handleTemplatesLoad = async () => {
        try {
            const data = await this.env.http
                .get(`ai_templates/`)
                .then(response => response.data);
            this.localState.templates = data.templates || [];
        } catch (e) {
            console.log(e);
            this.env.alert(
                'Ошибка',
                `Ошибка. Данные шаблонов не получены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
            );
        }
    };

    async componentDidMount() {
        try {
            if (this.store.auth.canShow.ai_reports) {
                await this.actions.generalProfileActions.fetchGeneralReports(this.store.generalProfile.selectedProfile.payer_id);
                await this.handleTemplatesLoad();
            }

        } catch (e) {
            console.log(e);
        }
    }

    handleAddReportClick = async (e) => {
        e.stopPropagation();
        this.localState.showAddReportTooltip = !this.localState.showAddReportTooltip;
        if (this.localState.showAddReportTooltip) {
            this.localState.newReportName = '';
            this.localState.newReportText = '';
            this.localState.save_template = false;
            await this.handleTemplatesLoad();
        }
    };

    handleRefreshReports = async () => {
        try {
            await this.actions.generalProfileActions.fetchGeneralReports(this.store.generalProfile.selectedProfile.payer_id);

            if (this.store.generalProfile.reports && 
                this.store.generalProfile.reports.some(report => report.is_processing) &&
                this.isPollingActive) {
                
                this.pollingTimeoutId = setTimeout(() => {
                    if (this.isPollingActive) {
                        this.handleRefreshReports();
                    }
                }, 5000);
            } else {
                this.stopPolling();
            }
        } catch (error) {
            console.error('Error refreshing reports:', error);
            this.stopPolling();
        }
    };

    startPolling = () => {
        this.isPollingActive = true;
        this.handleRefreshReports();
    };

    stopPolling = () => {
        this.isPollingActive = false;
        if (this.pollingTimeoutId) {
            clearTimeout(this.pollingTimeoutId);
            this.pollingTimeoutId = null;
        }
    };

    handleSubmitNewReport = async () => {

        try {
            if (this.localState.newReportName.trim() && this.localState.newReportText.trim()) {

                await this.env.http.post(
                    `account_reports/`,
                    {
                        name: this.localState.newReportName,
                        instruction: this.localState.newReportText,
                        instance_id: this.store.generalProfile.selectedProfile.payer_id,
                        save_template: this.localState.save_template,

                    }
                ).then((data) => {
                    const newReport = data.data.report;
                    this.store.generalProfile.reports.push(newReport);
                    this.store.generalProfile.activeReportId = newReport.id;
                    this.store.generalProfile.activeReport = newReport;

                    this.localState.showAddReportTooltip = false;
                    this.localState.newReportName = '';
                    this.localState.newReportText = '';
                    this.localState.save_template = false;

                    this.env.alert('Успех', 'Отчет успешно создан.');
                });
            }

            this.startPolling();

        } catch (error) {
            console.error(error);
            this.env.alert('Ошибка', 'Не удалось добавить новый отчет. Пожалуйста, попробуйте еще раз.');
            return;
        }

    };

    handleSubmitReportUpdate = async () => {
        try {
            if (this.localState.newReportName.trim() && this.localState.newReportText.trim()) {

                await this.env.http.post(
                    `account_reports/`,
                    {
                        report_id: this.localState.editReportId,
                        name: this.localState.newReportName,
                        instruction: this.localState.newReportText,
                        instance_id: this.store.generalProfile.selectedProfile.payer_id,
                        save_template: this.localState.save_template,
                    }
                ).then((data) => {
                    this.localState.showAddReportTooltip = false;
                    const updatedReport = data.data.report;

                    const reportIndex = this.store.generalProfile.reports.findIndex(report => report.id === this.localState.editReportId);
                    if (reportIndex !== -1) {
                        this.store.generalProfile.reports[reportIndex].name = updatedReport.name;
                        this.store.generalProfile.reports[reportIndex].instruction = updatedReport.instruction;
                        this.store.generalProfile.reports[reportIndex].result = updatedReport.result;
                        this.store.generalProfile.activeReport = this.store.generalProfile.reports[reportIndex];
                        this.store.generalProfile.activeReportId = this.store.generalProfile.reports[reportIndex].id;
                    }
                    this.localState.newReportName = '';
                    this.localState.newReportText = '';
                    this.localState.editReportId = null;
                    this.localState.save_template = false;
                    this.env.alert('Успех', 'Отчет успешно обновлен.');
                });
                this.startPolling();
            }
        } catch (error) {
            console.error(error);
            this.env.alert('Ошибка', 'Не удалось обновить отчет. Пожалуйста, попробуйте еще раз.');
            return;
        }

    };

    handleDeleteReport = async (reportId) => {
        try {
            await this.env.http.delete(`account_reports/${reportId}/`).then(() => {
                this.store.generalProfile.reports = this.store.generalProfile.reports.filter(report => report.id !== reportId);
                if (this.store.generalProfile.activeReportId === reportId) {
                    this.store.generalProfile.activeReportId = this.store.generalProfile.reports.length > 0 ? this.store.generalProfile.reports[0].id : null;
                    this.store.generalProfile.activeReport = this.store.generalProfile.reports.length > 0 ? this.store.generalProfile.reports[0] : {
                        id: null,
                        name: '',
                        instruction: '',
                        result: '',
                        date_updated: "TODAY",
                        date_created: "TODAY"
                    };
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    handleDeleteTemplate = async (templateId) => {
        try {
            await this.env.http.delete(`ai_templates/${templateId}/`).then(() => {
                this.localState.templates = this.localState.templates.filter(template => template.id !== templateId);
            });
        } catch (error) {
            console.error(error);
        }
    };

    handleEditReport = async (reportId) => {
        const report = this.store.generalProfile.reports.find(r => r.id === reportId);
        if (report) {
            this.store.generalProfile.activeReportId = report.id;
            this.store.generalProfile.activeReport = report;
            this.localState.newReportName = report.name;
            this.localState.newReportText = report.instruction;
            this.localState.editReportId = report.id;
            this.localState.showAddReportTooltip = true;
            this.localState.save_template = false;

            await this.handleTemplatesLoad();
        }
    };

    handleCancelAddReport = () => {
        this.localState.showAddReportTooltip = false;
        this.localState.newReportName = '';
        this.localState.newReportText = '';
        this.localState.editReportId = null;
        this.localState.save_template = false;
    };

    componentWillUnmount() {
        this.stopPolling();
    }

    render() {
        return (
            <div className='general_info__content'>
                {this.store.auth.canShow.ai_reports && (
                    <div className='report-row'>
                        <div className='general-sidebar-content'>
                            {this.localState.showAddReportTooltip ?
                                <div className='add-report-tooltip' onClick={(e) => e.stopPropagation()}>
                                    <div className='tooltip-content'>
                                        <h4>Новый отчет</h4>
                                        <input
                                            type='text'
                                            placeholder='Название отчета'
                                            value={this.localState.newReportName}
                                            onChange={(e) => this.localState.newReportName = e.target.value}
                                            className='report-name-input'
                                        />
                                        <textarea
                                            placeholder='Содержание отчета'
                                            value={this.localState.newReportText}
                                            onChange={(e) => this.localState.newReportText = e.target.value}
                                            className='report-text-textarea'
                                            rows={6}
                                        />
                                        <div className='save-template-checkbox'>
                                            <input
                                                type='checkbox'
                                                checked={this.localState.save_template}
                                                onChange={(e) => this.localState.save_template = e.target.checked}
                                            />
                                            <label>Сохранить как шаблон</label>
                                        </div>
                                        <div className='tooltip-buttons'>
                                            <button
                                                onClick={!this.localState.editReportId ? this.handleSubmitNewReport : this.handleSubmitReportUpdate}
                                                className='submit-button'
                                                disabled={!this.localState.newReportName.trim() || !this.localState.newReportText.trim()}
                                            >
                                                {!this.localState.editReportId ? 'Создать' : 'Обновить'}
                                            </button>
                                            <button
                                                onClick={this.handleCancelAddReport}
                                                className='cancel-button'
                                            >
                                                Отмена
                                            </button>
                                        </div>

                                        <ul className='report-list'
                                            style={{
                                                maxHeight: '200px',
                                                overflowY: 'scroll',
                                                marginTop: '2rem'
                                            }}>
                                            {this.localState.templates.map((template, idx) => {
                                                return (
                                                    <li key={idx} className='report-item' onClick={(e) => {

                                                        if (e.target.closest('.report-delete') ||
                                                            e.target.closest('button')) {
                                                            return;
                                                        }
                                                        this.localState.newReportName = template.name;
                                                        this.localState.newReportText = template.instruction;
                                                        this.localState.save_template = false;
                                                    }}>
                                                        <div className='report-title'>{template.name}</div>
                                                        <div className='report-edit-buttons'>
                                                            <button
                                                                className='report-delete'
                                                                onClick={() => { this.handleDeleteTemplate(template.id) }}>
                                                                удалить
                                                            </button>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>

                                    </div>
                                </div>
                                :
                                <ul className='report-list'>
                                    {this.store.generalProfile.reports.map((report, idx) => {
                                        return (
                                            <li key={idx} className={`report-item` + (this.store.generalProfile.activeReportId === report.id ? ' active' : '')}
                                                onClick={(e) => {
                                                    if (e.target.closest('.report-delete') ||
                                                        e.target.closest('button')) {
                                                        return;
                                                    }
                                                    this.store.generalProfile.activeReportId = report.id;
                                                    this.store.generalProfile.activeReport = report;
                                                }}>
                                                <div className='report-title'>{report.name}</div>
                                                <div className='report-date'>{report.date_updated || report.date_created}</div>
                                                <div className='report-edit-buttons'>
                                                    <button
                                                        className='report-edit'
                                                        onClick={() => { this.handleEditReport(report.id) }}>
                                                        edit
                                                    </button>
                                                    <button
                                                        className='report-delete'
                                                        onClick={() => { this.handleDeleteReport(report.id) }}>
                                                        delete
                                                    </button>
                                                </div>

                                            </li>
                                        );
                                    })}

                                    <li className='add-report-item' onClick={this.handleAddReportClick}>
                                        <div className='report-title'>Добавить отчет</div>
                                    </li>
                                </ul>
                            }


                        </div>
                        <div className='general-report-content'>
                            <iframe className='report-text'
                                srcDoc={this.store.generalProfile.activeReport.result}
                                title={this.store.generalProfile.activeReport.name}>
                            </iframe>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Component({ namespaces: ['general-ai-report'] })(GeneralAiReport);